import { Directive, effect, ElementRef, inject } from '@angular/core';
import { SkinningService } from '../services/skinning.service';

@Directive({
  standalone: true,
  selector: '[igImageFilter]',
})
export class ImageFilterDirective {
  readonly #el = inject(ElementRef);
  readonly #skinningService = inject(SkinningService);

  constructor() {
    effect(() => {
      const darkmodeColor = this.#skinningService.darkModeColorHsl();
      const lightmodeColor = this.#skinningService.primaryColorHsl();

      const baseColor = this.#skinningService.darkMode() ? darkmodeColor : lightmodeColor;

      if (baseColor) {
        const computations = this.#skinningService.darkMode()
          ?
          [
            // credits for this computation to: https://stackoverflow.com/questions/29037023/how-to-calculate-required-hue-rotate-to-generate-specific-colour
            'brightness(70%)',
            'sepia(1)',
            'hue-rotate(' + (baseColor.h - 38) + 'deg)',
            'saturate(' + (100 + 24.5 - baseColor.s) + '%)',
            'brightness(' + (100 + baseColor.l - 60) + '%)'
          ]
          :
          [
            // 'brightness(70%)',
            'grayscale(100%)'
          ]
          ;


        (this.#el.nativeElement as HTMLElement).style.filter = computations.join(' ');
      }

    })
  }
}
